import axios from "axios";
//const BASE_URL = "http://localhost/ciproject/public/";
const BASE_URL = "https://api-test.diamondthreading.com/";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});
